import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "card-body d-flex flex-column" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "d-flex flex-column mb-7" }, [
  /*#__PURE__*/_createVNode("a", {
    href: "#",
    class: "text-dark text-hover-primary fw-bolder fs-3"
  }, "Summary")
], -1)
const _hoisted_3 = { class: "row g-0" }
const _hoisted_4 = { class: "col-6" }
const _hoisted_5 = { class: "d-flex align-items-center mb-9 me-2" }
const _hoisted_6 = { class: "symbol symbol-40px me-3" }
const _hoisted_7 = { class: "symbol-label bg-white bg-opacity-50" }
const _hoisted_8 = { class: "svg-icon svg-icon-1 svg-icon-dark" }
const _hoisted_9 = /*#__PURE__*/_createVNode("div", null, [
  /*#__PURE__*/_createVNode("div", { class: "fs-5 text-dark fw-bolder lh-1" }, "$50K"),
  /*#__PURE__*/_createVNode("div", { class: "fs-7 text-gray-600 fw-bold" }, "Sales")
], -1)
const _hoisted_10 = { class: "col-6" }
const _hoisted_11 = { class: "d-flex align-items-center mb-9 ms-2" }
const _hoisted_12 = { class: "symbol symbol-40px me-3" }
const _hoisted_13 = { class: "symbol-label bg-white bg-opacity-50" }
const _hoisted_14 = { class: "svg-icon svg-icon-1 svg-icon-dark" }
const _hoisted_15 = /*#__PURE__*/_createVNode("div", null, [
  /*#__PURE__*/_createVNode("div", { class: "fs-5 text-dark fw-bolder lh-1" }, "$4,5K"),
  /*#__PURE__*/_createVNode("div", { class: "fs-7 text-gray-600 fw-bold" }, "Revenue")
], -1)
const _hoisted_16 = { class: "col-6" }
const _hoisted_17 = { class: "d-flex align-items-center me-2" }
const _hoisted_18 = { class: "symbol symbol-40px me-3" }
const _hoisted_19 = { class: "symbol-label bg-white bg-opacity-50" }
const _hoisted_20 = { class: "svg-icon svg-icon-1 svg-icon-dark" }
const _hoisted_21 = /*#__PURE__*/_createVNode("div", null, [
  /*#__PURE__*/_createVNode("div", { class: "fs-5 text-dark fw-bolder lh-1" }, "40"),
  /*#__PURE__*/_createVNode("div", { class: "fs-7 text-gray-600 fw-bold" }, "Tasks")
], -1)
const _hoisted_22 = { class: "col-6" }
const _hoisted_23 = { class: "d-flex align-items-center ms-2" }
const _hoisted_24 = { class: "symbol symbol-40px me-3" }
const _hoisted_25 = { class: "symbol-label bg-white bg-opacity-50" }
const _hoisted_26 = { class: "svg-icon svg-icon-1 svg-icon-dark" }
const _hoisted_27 = /*#__PURE__*/_createVNode("div", null, [
  /*#__PURE__*/_createVNode("div", { class: "fs-5 text-dark fw-bolder lh-1" }, "$5.8M"),
  /*#__PURE__*/_createVNode("div", { class: "fs-7 text-gray-600 fw-bold" }, "Sales")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createBlock("div", {
    class: [_ctx.widgetClasses, "card"],
    style: `background-color: ${_ctx.widgetColor}`
  }, [
    _createVNode("div", _hoisted_1, [
      _hoisted_2,
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _createVNode("div", _hoisted_6, [
              _createVNode("div", _hoisted_7, [
                _createVNode("span", _hoisted_8, [
                  _createVNode(_component_inline_svg, { src: "media/icons/duotune/abstract/abs043.svg" })
                ])
              ])
            ]),
            _hoisted_9
          ])
        ]),
        _createVNode("div", _hoisted_10, [
          _createVNode("div", _hoisted_11, [
            _createVNode("div", _hoisted_12, [
              _createVNode("div", _hoisted_13, [
                _createVNode("span", _hoisted_14, [
                  _createVNode(_component_inline_svg, { src: "media/icons/duotune/abstract/abs046.svg" })
                ])
              ])
            ]),
            _hoisted_15
          ])
        ]),
        _createVNode("div", _hoisted_16, [
          _createVNode("div", _hoisted_17, [
            _createVNode("div", _hoisted_18, [
              _createVNode("div", _hoisted_19, [
                _createVNode("span", _hoisted_20, [
                  _createVNode(_component_inline_svg, { src: "media/icons/duotune/abstract/abs022.svg" })
                ])
              ])
            ]),
            _hoisted_21
          ])
        ]),
        _createVNode("div", _hoisted_22, [
          _createVNode("div", _hoisted_23, [
            _createVNode("div", _hoisted_24, [
              _createVNode("div", _hoisted_25, [
                _createVNode("span", _hoisted_26, [
                  _createVNode(_component_inline_svg, { src: "media/icons/duotune/abstract/abs045.svg" })
                ])
              ])
            ]),
            _hoisted_27
          ])
        ])
      ])
    ])
  ], 6))
}